__turbopack_context__.v({
  "headerText": "joinWaitlistModal-module-scss-module__OMUkpG__headerText",
  "modalDescription": "joinWaitlistModal-module-scss-module__OMUkpG__modalDescription",
  "nameInputs": "joinWaitlistModal-module-scss-module__OMUkpG__nameInputs",
  "recaptchaContainer": "joinWaitlistModal-module-scss-module__OMUkpG__recaptchaContainer",
  "textarea": "joinWaitlistModal-module-scss-module__OMUkpG__textarea",
});
